import { units } from '@ui/css';
import { combineTokens, makeScaleableToken, makeSelectors } from '@utils/css';

const props = combineTokens("--chevron", {
  lineColor: "currentColor",
  lineWidth: [units.px(2), makeScaleableToken],
  size: [units.px(10), makeScaleableToken],
  pythagoreanSize: units.px(14.1421)
});

/* Calculate height of the chevron, using the Pythagorean theorem */

const chevronCls = "_ecc1ngeoxx";
const horitzontalLineCls = "_echv7yup6";
const verticalLineCls = "_ecv13bxk9y";
const selectors = makeSelectors({
  chevron: chevronCls,
  verticalLine: verticalLineCls,
  horizontalLine: horitzontalLineCls
});

export { chevronCls, horitzontalLineCls, props, selectors, verticalLineCls };
import "./styles.linaria.module.css";
//# sourceMappingURL=styles.js.map
